// extracted by mini-css-extract-plugin
export default {"container":"expandible_container__hzbBA","collapse2":"expandible_collapse2__4nYOI","up":"expandible_up__wRr3U","down":"expandible_down__ibhMb","rotate":"expandible_rotate__Tuj7+"};